import { Interweave } from 'interweave';
import React from 'react';
import styled from 'styled-components';
import media from '../../../constants/media';
import { tableDataStyles, tableHeaderStyles, tableRowStyles, tableStyles } from '../table/table';
import {
	asAnchor,
	asHeading1,
	asHeading2,
	asHeading3,
	asHeading4,
	asHeading5,
	liStyles,
	paragraphStyles,
	strongStyles,
	ulStyles,
} from '../typography';

export const ArticleRichTextStyleWrapper = styled.div`
	h1 {
		${asHeading1};
		margin-bottom: 3rem;
		margin-top: 2rem;
	}

	h2 {
		${asHeading2};
		margin-bottom: 3rem;
		margin-top: 2rem;
	}

	h3 {
		${asHeading3};
		margin-bottom: 3rem;
		margin-top: 2rem;
	}

	h4 {
		${asHeading4};
		margin-bottom: 2rem;
		font-family: ${({ theme }) => theme.fonts.SharpSlab};
		font-weight: 700;
		font-size: 24px;
		line-height: 120%;
		letter-spacing: -0.7px;
	}

	h5 {
		${asHeading5};
		margin-bottom: 3rem;
		margin-top: 2rem;
	}

	h6 {
		text-align: center;
		font-size: 14px;
		line-height: 32px;
		color: ${({ theme }) => theme.colorsV2.grey6};
		font-weight: regular;
		margin-bottom: 24px;
		${media.tablet`
      font-size: 18px;
      line-height: 32px;
      margin-bottom: 32px;
    `};
	}

	ul {
		${ulStyles};
		margin-bottom: 3rem;
	}

	li {
		${liStyles};
	}

	a {
		${asAnchor};
	}

	p {
		${paragraphStyles};
		color: ${({ theme }) => theme.colorsV2.mainDark};
		font-size: 14px;
		line-height: 22px !important;
		${media.tablet`
        font-size: 18px;
        line-height: 32px !important;
    `};
	}

	img {
		min-width: 100%;
		margin: 0 0 !important;
	}

	strong {
		${strongStyles};
	}

	blockquote {
		display: block;
		position: relative;
		margin: 8rem 0;

		font-size: 2.8rem;
		line-height: 3.8rem;
		font-family: ${({ theme }) => theme.fonts.ArimoRegular};
		font-style: italic;
		font-weight: 300;
		color: ${({ theme }) => theme.colors.secondary};
		span {
			font-size: 2rem !important;
			line-height: 4.7rem !important;
			color: ${({ theme }) => theme.colors.textDark} !important;
			font-family: ${({ theme }) => theme.fonts.ArimoRegular} !important;
		}
		overflow: visible;
		&:before {
			padding: 3rem;
			margin: -3rem;
			left: -10px;
			content: '„';
			background-image: url('/dist/icons/quotes.svg');
			overflow: visible;
			position: absolute;
			width: 175px;
			height: 153px;
			background-repeat: no-repeat;
			z-index: -1;
		}

		&:after {
			content: '“';
		}

		p {
			display: inline;
		}
	}

	table {
		${tableStyles};
		display: block;
		height: auto !important;
		width: 100% !important;
		overflow-x: auto;
		max-width: 100vw;
	}

	tr {
		${tableRowStyles};
		display: table-row;
	}

	th {
		${tableDataStyles};
		${tableHeaderStyles};
		display: table-cell;
		padding-left: 1.5rem;
	}

	td {
		${tableDataStyles};
		display: table-cell;
		padding-left: 1.5rem;
	}

	iframe {
		max-width: 100%;
		max-height: calc(100vw / (16 / 9));
	}
`;

export const ArticleStyledRichText = props => (
	<ArticleRichTextStyleWrapper>
		<Interweave {...props} tagName="fragment" allowElements />
	</ArticleRichTextStyleWrapper>
);
